import { render, staticRenderFns } from "./DropdownHost.vue?vue&type=template&id=eddc7678&scoped=true&"
import script from "./DropdownHost.vue?vue&type=script&lang=js&"
export * from "./DropdownHost.vue?vue&type=script&lang=js&"
import style0 from "./DropdownHost.vue?vue&type=style&index=0&id=eddc7678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc7678",
  null
  
)

export default component.exports